// PostHog 초기화를 지연하여 FCP/TBT 개선 (Lighthouse 권장)
function initPostHog() {
  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (typeof window === 'undefined' || !apiKey) return;

  import('posthog-js').then(({ default: posthog }) => {
    try {
      const hasLocalStorage = (() => {
        try {
          const test = '__localStorage_test__';
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
        } catch {
          return false;
        }
      })();

      posthog.init(apiKey, {
        api_host: '/ingest',
        ui_host: 'https://us.posthog.com',
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: process.env.NODE_ENV === 'development',
        persistence: hasLocalStorage ? 'localStorage+cookie' : 'memory',
        disable_session_recording: !hasLocalStorage,
        disable_surveys: false,
        session_recording: {
          // 모든 인풋 마스킹 해제 - password 타입만 선택적으로 마스킹
          maskAllInputs: false,
          maskInputFn: (text, element) => {
            if ((element as HTMLInputElement)?.type === 'password') {
              return '*'.repeat(text.length);
            }
            return text;
          },
        },
        loaded: () => {
          if (!hasLocalStorage) {
            console.info(
              'PostHog: Running in memory-only mode (incognito/private browsing detected)'
            );
          }
        },
      });
    } catch (error) {
      console.error('Failed to initialize PostHog:', error);
    }
  });
}

// requestIdleCallback으로 초기 로드 후 지연 실행 (없으면 setTimeout 2초)
if (typeof window !== 'undefined') {
  const schedule = (cb: () => void) => {
    if ('requestIdleCallback' in window) {
      (
        window as Window & {
          requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void;
        }
      ).requestIdleCallback(cb, { timeout: 3000 });
    } else {
      setTimeout(cb, 2000);
    }
  };
  schedule(initPostHog);
}
